export { DealerLocatorFooter } from './dealer-locator-footer';
